export type TFinancialsList = {
  start_period: string
  amount: string
  status: string
  type: string
  facility_name: string
  contract_id: string
  contract_number: string
  vendor_id: string
  vendor_name: string
  uuid: string
}

export type TCommunityProcessingItem = {
  uuid: string
  name: string
  count_hs_without_value: number
  key?: string
}

export type TDeclineValue = {
  decline_reason: string
}

export enum DueDateStatuses {
  DUE_SOON = 'due_soon',
  OVERDUE = 'overdue'
}

export enum FINANCIAL_STATUS {
  PAYMENT_IN_PROGRESS = 'payment_in_progress',
  PAID = 'paid',
  PAYMENT_FAILED = 'payment_failed',
  PAST_DUE = 'past_due',
  DISPUTED = 'disputed',
  WAITING_FOR_RESPONSE = 'waiting_for_response',
  PARTIALLY_PAID = 'partially_paid'
}

export type PaymentStatus = Omit<PaymentStatusData, 'percentage'> & {
  percentage: string
}

export type SelectedRowData = {
  uuid: string
  supplier: string
  health_system: string
  total: number
}

export enum PAYMENT_TYPES {
  ADMIN_FEE = 'Admin Fee',
  REBATES = 'Rebates',
  COGNUS_AR = 'Cognus AR',
  MARKETPLACE_AR = 'Marketplace AR'
}

export type PaymentStatusData = {
  amount: number
  percentage: number
  status: string
}

export enum TRANSFER_STATUSES {
  COMPLETED = 'completed',
  CREATED = 'created',
  FAILED = 'failed',
  PENDING = 'pending',
  SETTLED = 'settled'
}

export enum DESTINATION_TYPES {
  HEALTH_SYSTEM = 'health_system',
  COMMONS = 'commons',
  HOSPITAL = 'hospital'
}

export type TransferData = {
  amount: string
  currency: string
  destination_type: DESTINATION_TYPES
  status: TRANSFER_STATUSES
  uuid: string
}
